import theme from "app/Theme/Theme";
import React from "react";

const styles = {
  openableCardContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    marginRight: theme.spacing.l,
    height: "100%",
  },
};

export const OpenableCard = ({ leftSide, openableSide, isOpen }) => {
  return (
    <div style={styles.openableCardContainer}>
      {leftSide}
      {isOpen && (
        <div
          style={{
            transitionDuration: "0.5s",
            width: 400,
          }}
        >
          {openableSide}
        </div>
      )}
    </div>
  );
};
